/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'@waca/dashboard-common/js/core/APIFactory',
	'./api/QueryResultAPI',
	'./ResultItem',
	'../../../widgets/livewidget/query/QueryResultData'
], (APIFactory, QueryResultAPI, ResultItem, QueryResultData) => {
	class QueryResultDataImpl extends QueryResultData {
		constructor(queryResultObj) {
			super(queryResultObj);
			this.getResultItemList = this.getResultDataItems.bind(this);
			this.getDataPointValueList = this.getDatapoints.bind(this);
			this.getRowCount = this.getDatapointCount.bind(this);
			this.properties = {};
		}

		destroy() {
			this.properties = null;
		}

		getPropertyValue(name) {
			return this.properties[name];
		}

		setPropertyValue(name, value) {
			if (typeof (name) !== 'string'){
				throw new Error('Name must be a string');
			}
			if (value !== null && typeof (value) !== 'string'){
				throw new Error('Value must be a string');
			}
			this.properties[name] = value;
		}

		getAPI() {
			if (!this.queryResultAPI) {
				this.queryResultAPI = APIFactory.createAPI(this, [QueryResultAPI]);
			}
			return this.queryResultAPI;
		}

		_generateDataItemArray() {
			this._aQueryResultDataItems = [];
			if(this._resultData && this._resultData.dataItems && this._resultData.dataItems.length > 0) {
				this._resultData.dataItems.forEach(dataItem => {
					if (this._isValidDataItem(dataItem)) {
						this._aQueryResultDataItems.push(new ResultItem(dataItem).getAPI());
					}
				});
			}
		}

		getResultItem(resultDataItemID) {
			return this.getResultItemList().find(resultDataItemAPI => resultDataItemID === resultDataItemAPI.getId());
		}

		//TODO: delete value.v when when all consumers are ready to new qeury APIs
		getValue(rowIndex, resultDataItemIndex) {
			let value = undefined;
			const dataPointValueList = this.getDataPointValueList();
			const dataPoint = dataPointValueList && dataPointValueList[rowIndex];
			if (dataPoint) {
				value = dataPoint.pt[resultDataItemIndex];
				if (typeof value === 'object' && (value.v !== undefined || value.value !== undefined)) {
					// result is a value of a measure column
					if (value.value === undefined) {
						value.value = value.v;
					}
				} else {
					// value is the row index of resultItemList
					const resultItemList = this.getResultItemList();
					value = resultItemList && resultItemList[resultDataItemIndex].getValue(value);
				}
			}
			return value;
		}

		getValueIndex(rowIndex, resultDataItemIndex) {
			//Similar to getValue for categoricals except that it returns the index in the 'edge' where the tuple value is found.
			let value = undefined;
			const dataPointValueList = this.getDataPointValueList();
			const dataPoint = dataPointValueList && dataPointValueList[rowIndex];
			if(dataPoint) {
				value = dataPoint.pt[resultDataItemIndex];
				if (typeof value === 'object') {
					throw new Error('getValueIndex is only supported for categorical items.');
				}
			}
			return value;
		}

		getPointDecorations(rowIndex) {
			const dataPointValueList = this.getDataPointValueList();
			const dataPoint = dataPointValueList && dataPointValueList[rowIndex];
			const dataPointDecos = dataPoint && dataPoint.deco && JSON.parse(JSON.stringify(dataPoint.deco)) || {};
			return dataPointDecos;
		}

		setPointDecorations(rowIndex, decorations) {
			const dataPointValueList = this.getDataPointValueList();
			const dataPoint = dataPointValueList && dataPointValueList[rowIndex];
			if (dataPoint) {
				dataPoint.deco = decorations;
			}
		}
	}

	return QueryResultDataImpl;
});